export default __webpack_public_path__ + "static/media/dt1.feb270dd.jpg";